import { render } from "./PartnerHome.vue?vue&type=template&id=eef22646&scoped=true"
import script from "./PartnerHome.vue?vue&type=script&lang=js"
export * from "./PartnerHome.vue?vue&type=script&lang=js"

import "./PartnerHome.vue?vue&type=style&index=0&id=eef22646&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eef22646"]])

export default __exports__